import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import LandingVSL from "@/pages/LandingVSL";
import LandingVSLSplit from "@/pages/LandingVSLSplit";
import DivorceVSL from "@/pages/DivorceVSL";
import DivorceVSLSplit from "@/pages/DivorceVSLSplit";
import PrenupVSL from "@/pages/PrenupVSL";
import PrenupVSLSplit from "@/pages/PrenupVSLSplit";
import DomesticViolenceVSL from "@/pages/DomesticViolenceVSL";
import DomesticViolenceVSLSplit from "@/pages/DomesticViolenceVSLSplit";
import Divorce from "@/pages/Divorce";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsOfUse from "@/pages/TermsOfUse";
import AdminLogin from "@/pages/AdminLogin";
import AdminLeads from "@/pages/AdminLeads";
import DomesticViolence from "@/pages/DomesticViolence";
import HighAsset from "@/pages/HighAsset";
import Prenup from "@/pages/Prenup";
import ExternalRedirect from "@/pages/ExternalRedirect";
import { Toaster } from "sonner";

export default function App() {
  return (
    <div className="App font-body text-ink bg-paper antialiased">
      <BrowserRouter>
        <Routes>
          {/* Campaign landing pages */}
          <Route
            path="/child-custody-attorney-orange-county"
            element={<Landing />}
          />
          <Route
            path="/child-custody-attorney-orange-county-vsl"
            element={<LandingVSL />}
          />
          <Route
            path="/child-custody-attorney-orange-county-vsl-v2"
            element={<LandingVSLSplit />}
          />

          <Route
            path="/orange-county-divorce-attorney-vsl"
            element={<DivorceVSL />}
          />
          <Route
            path="/orange-county-divorce-attorney-vsl-v2"
            element={<DivorceVSLSplit />}
          />

          <Route
            path="/prenuptial-agreement-attorney-orange-county-vsl"
            element={<PrenupVSL />}
          />
          <Route
            path="/prenuptial-agreement-attorney-orange-county-vsl-v2"
            element={<PrenupVSLSplit />}
          />

          <Route
            path="/domestic-violence-attorney-orange-county-vsl"
            element={<DomesticViolenceVSL />}
          />
          <Route
            path="/domestic-violence-attorney-orange-county-vsl-v2"
            element={<DomesticViolenceVSLSplit />}
          />
          <Route
            path="/orange-county-divorce-attorney"
            element={<Divorce />}
          />

          {/* Legal */}
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-use" element={<TermsOfUse />} />

          {/* Admin */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/leads" element={<AdminLeads />} />
          <Route
            path="/domestic-violence-attorney-orange-county"
            element={<DomesticViolence />}
          />
          <Route
            path="/high-asset-divorce-attorney-orange-county"
            element={<HighAsset />}
          />
          <Route
            path="/prenuptial-agreement-attorney-orange-county"
            element={<Prenup />}
          />

          {/* Root + any unmatched path → main firm website */}
          <Route path="/" element={<ExternalRedirect />} />
          <Route path="*" element={<ExternalRedirect />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors closeButton theme="light" />
    </div>
  );
}
